import * as React from 'react'
import { Link, Navigate, useParams } from 'react-router-dom'
import { decodeRouteParam, graphHighlightHref } from '@atbash-labs/plantview-links'
import { useGetAuthzMeQuery, useGetPlantEntityQuery } from '@axilon-apps/domains-ontology-ui-state'
import { Button } from '../../../components/ui/button'
import { canOpenTagsPage } from '../../TagsPage/tags-page-access'
import { BESPOKE_ENTITY_PAGE_BY_LABEL } from './bespoke-entity-pages'
import { resolveEntitySurface } from './entity-surface'
import { GenericEntityPage } from './GenericEntityPage'

export default function EntityResolverPage(): React.ReactElement {
  const { id = '' } = useParams<{ id: string }>()
  const entityId = decodeRouteParam(id)
  const { data, isLoading, isError } = useGetPlantEntityQuery(entityId, { skip: !entityId })
  const { data: authz, isLoading: authzLoading } = useGetAuthzMeQuery()

  if (isLoading || authzLoading) {
    return <div className="rounded-xl border bg-card p-8 text-sm text-ink-3">Loading entity…</div>
  }
  if (isError || !data) {
    return (
      <div className="rounded-xl border bg-card p-8 text-card-foreground shadow-sm">
        <h1 className="m-0 text-xl font-semibold">Entity not found</h1>
        <p className="mt-2 break-all font-mono text-xs text-ink-3">{entityId}</p>
        <Button asChild variant="outline" className="mt-5">
          <Link to={graphHighlightHref(entityId)}>Open graph view</Link>
        </Button>
      </div>
    )
  }

  const decision = resolveEntitySurface(data, { canOpenTagsPage: canOpenTagsPage(authz) })
  if (decision.kind === 'redirect') return <Navigate replace to={decision.href} />
  if (decision.label) {
    const BespokePage = BESPOKE_ENTITY_PAGE_BY_LABEL[decision.label]
    if (BespokePage) {
      return <BespokePage entityId={data.entity.id} label={decision.label} />
    }
  }
  return <GenericEntityPage result={data} label={decision.label} />
}
